export default __webpack_public_path__ + "static/media/banner-informativo-info-pagamento-meus-produtos.cddd8028.jpeg";